module.exports = __webpack_public_path__ + "static/media/cube_l.a74d3779.svg";